module.exports = __webpack_public_path__ + "img/index_part2img7.8b4b2871.jpg";